// extracted by mini-css-extract-plugin
export default {"template":"Template_template__jxYDJ"};